import React from 'react';
import moment from 'moment';
import FontAwesome from 'react-fontawesome';
import * as MaterialUI from 'material-ui';
import { connect } from 'react-redux';
import { Row, Col } from 'reactstrap';
import { checkPermissions } from 'core/generalFunctions';

/*
Props:

cancelarReserva
editReserva
reservaPasajero
concretarReserva
*/
@connect()
export class ItemListPasajeroC extends React.Component {
  render() {
    const { reservaPasajero } = this.props;
    let usuario = reservaPasajero.get('_usuario'),
      tipoUsuario = 'mobile';
    if (!usuario) {
      if (reservaPasajero.get('_usuarioAbonado')) {
        usuario = reservaPasajero.get('_usuarioAbonado');
        tipoUsuario = 'user';
      } else {
        usuario = reservaPasajero.get('_usuarioCasual');
        tipoUsuario = 'user-circle';
      }
    }

    let contoTotalPenalizacion = 0;
    if (usuario.get('_penalizacion')) usuario.get('_penalizacion').map((penalizacion) => (contoTotalPenalizacion += penalizacion.get('costo')));
    return (
      <div className={reservaPasajero.get('cancelada') ? 'noMargin no-print' : 'noMargin'}>
        <MaterialUI.ListItem
          className="noMargin printSmallList"
          innerDivStyle={{ padding: '16px 180px 16px 16px', className: 'innerDiv' }}
          style={{ backgroundColor: reservaPasajero.get('cancelada') ? '#f5f5f5' : false }}
          disabled={reservaPasajero.get('cancelada')}
          onClick={() => checkPermissions(['admin', 'administrador_reservas']) && this.props.editReserva(reservaPasajero.get('id'))}
          rightIconButton={
            !reservaPasajero.get('cancelada') &&
            checkPermissions(['admin', 'administrador_reservas']) && (
              <div className="no-print pt-20">
                <MaterialUI.RaisedButton
                  style={{ minWidth: '40px', marginLeft: 5, marginRight: 5 }}
                  icon={
                    <div>
                      <FontAwesome name="usd" className="white" />
                      {Boolean(contoTotalPenalizacion) && <FontAwesome name="exclamation-triangle" className="white" style={{ paddingLeft: '5px' }} />}
                    </div>
                  }
                  onClick={(e) => {
                    e.stopPropagation();
                    this.props.abonarReserva(
                      reservaPasajero.get('id'),
                      !reservaPasajero.get('abonada'),
                      reservaPasajero.get('viajeId'),
                      reservaPasajero.get('cuentaCorriente'),
                      usuario.get('_penalizacion'),
                    );
                  }}
                  backgroundColor={reservaPasajero.get('abonada') ? '#B71C1C' : '#00bad3'}
                />
                <MaterialUI.RaisedButton
                  style={{ minWidth: '40px', marginLeft: 5, marginRight: 5 }}
                  icon={
                    <div>
                      <FontAwesome name="creative-commons" className="white" />
                    </div>
                  }
                  onClick={(e) => {
                    e.stopPropagation();
                    this.props.abonarReserva(reservaPasajero.get('id'), reservaPasajero.get('abonada'), reservaPasajero.get('viajeId'), !reservaPasajero.get('cuentaCorriente'));
                  }}
                  backgroundColor={reservaPasajero.get('cuentaCorriente') ? '#B71C1C' : 'green'}
                />
                <MaterialUI.RaisedButton
                  style={{ minWidth: '40px', marginLeft: 5, marginRight: 5 }}
                  icon={<FontAwesome name="check" className="white" />}
                  onClick={(e) => {
                    e.stopPropagation();
                    this.props.concretarReserva(reservaPasajero.get('id'), !reservaPasajero.get('concretada'), reservaPasajero.get('viajeId'));
                  }}
                  backgroundColor={reservaPasajero.get('concretada') ? '#B71C1C' : '#00bad3'}
                />
                <MaterialUI.RaisedButton
                  style={{ minWidth: '40px', marginLeft: 5, marginRight: 5 }}
                  icon={<FontAwesome name="trash" className="white" />}
                  onClick={(e) => {
                    e.stopPropagation();
                    this.props.cancelarReserva(reservaPasajero.get('id'));
                  }}
                  backgroundColor="#B71C1C"
                />
                {(reservaPasajero.get('_usuarioAbonado') || reservaPasajero.get('_usuario')) && (
                  <MaterialUI.RaisedButton
                    style={{ minWidth: '30px', marginLeft: 5, marginRight: 5 }}
                    icon={<FontAwesome name="user" className="white" />}
                    onClick={(e) => {
                      e.stopPropagation();
                      this.props.goToAbonado(reservaPasajero.getIn(['_usuario', 'id']), reservaPasajero.getIn(['_usuarioAbonado', 'id']));
                    }}
                    backgroundColor="#00bad3"
                  />
                )}
              </div>
            )
          }
          primaryText={
            <Row>
              <Col md="4" className="textPasajerosPrint">
                <p className="p-lr-10">
                  <FontAwesome style={{ fontSize: 20 }} name={tipoUsuario} className="green" />
                  {usuario && usuario.get('nombre') ? ' ' + usuario.get('nombre') : ' Pasajero'}
                  {usuario && usuario.get('apellido') ? ' ' + usuario.get('apellido') : ''}
                </p>
                {reservaPasajero.get('_canceladaBy') && (
                  <p className="p-lr-10">
                    <FontAwesome name="ticket" className="red iconInfo pr-10" />
                    {reservaPasajero.getIn(['_canceladaBy', 'nombre'])} {reservaPasajero.getIn(['_canceladaBy', 'apellido'])}
                  </p>
                )}
                {reservaPasajero.getIn(['_canceladaBy', 'documento']) == usuario.get('documento') && reservaPasajero.getIn(['_canceladaBy', 'id']) != usuario.get('id') && (
                  <p className="no-print p-lr-10">
                    <FontAwesome name="warning" className="yellow iconInfo pr-10" />
                    Reserva cancelada por otro pasajero con el mismo documento
                  </p>
                )}
                {reservaPasajero.get('_creadaBy') && usuario.get('documento') != reservaPasajero.getIn(['_creadaBy', 'documento']) && (
                  <p className="p-lr-10 no-print">
                    <FontAwesome name="ticket" className="green iconInfo pr-10" />
                    {reservaPasajero.getIn(['_creadaBy', 'nombre'])} {reservaPasajero.getIn(['_creadaBy', 'apellido'])}
                  </p>
                )}
                <p className="p-lr-10">
                  <FontAwesome name="address-card-o" /> {usuario && usuario.get('documento')}
                </p>
                {Boolean(contoTotalPenalizacion) && (
                  <p className="p-lr-10">
                    <FontAwesome name="usd" className="red" /> {contoTotalPenalizacion}
                  </p>
                )}
              </Col>
              <Col md="4">
                {reservaPasajero.get('_paradaSubida') && (
                  <p>
                    <b>
                      <FontAwesome name="map-marker" className="no-print" />
                      <FontAwesome name="level-up" className="no-print" /> {reservaPasajero.getIn(['_paradaSubida', 'alias']) || reservaPasajero.getIn(['_paradaSubida', 'nombre'])}
                    </b>
                  </p>
                )}
                {reservaPasajero.get('_paradaBajada') && (
                  <p>
                    <i>
                      <FontAwesome name="map-marker" className="no-print" />
                      <FontAwesome name="level-down" className="no-print" /> {reservaPasajero.getIn(['_paradaBajada', 'alias']) || reservaPasajero.getIn(['_paradaBajada', 'nombre'])}
                    </i>
                  </p>
                )}
              </Col>
              <Col md="3">
                {reservaPasajero.get('confirmada') && !reservaPasajero.get('cancelada') && <FontAwesome name="check" className="green iconInfo pr-10" />}
                {reservaPasajero.get('cancelada') && <FontAwesome name="ban" className="red iconInfo pr-10" />}
                {!reservaPasajero.get('cancelada') && reservaPasajero.get('concretada') && <FontAwesome name="check" className="blue iconInfo pr-10" />}
                {reservaPasajero.get('usuarioApp') && !reservaPasajero.get('abonoId') && <FontAwesome name="mobile" className="yellow iconBar pr-10" />}
                {reservaPasajero.get('usuarioApp') && reservaPasajero.get('abonoId') && <FontAwesome name="mobile" className="green iconBar pr-10" />}
                {reservaPasajero.get('reservaAutomaticaId') && <FontAwesome name="calendar" className="blue iconInfo pr-10" />}
                {reservaPasajero.get('creadaPorChofer') && <FontAwesome name="bus" className="blue iconInfo pr-10" />}
                {reservaPasajero.get('canceladaPorNoConfimacion') && <FontAwesome name="clock-o" className="red iconInfo pr-10" />}
                {reservaPasajero.get('abonada') && <FontAwesome name="usd" className="green iconBar pr-10" />}
                {reservaPasajero.get('cuentaCorriente') && <FontAwesome name="creative-commons" className="blue iconBar pr-10" />}
              </Col>
            </Row>
          }
        />
        <MaterialUI.Divider />
      </div>
    );
  }
}

/*
Props:

reservaPasajero
*/
export class ItemListPasajeroTemporalC extends React.Component {
  render() {
    let reservaPasajero = this.props.reservaPasajero;
    return (
      <div>
        <MaterialUI.ListItem
          className="noMargin"
          primaryText={
            <Row className="listIcon p-lr-10 gray">
              <Col md="2">
                <p>
                  <FontAwesome name="history" />
                </p>
              </Col>
              <Col md="3">
                <p>Reserva temporal</p>
              </Col>
              <Col md="3">
                <p>Creada: {moment(reservaPasajero.get('fechaRealizada')).format('LT')}</p>
              </Col>
            </Row>
          }
        />
        <MaterialUI.Divider />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// src/modules/viajes/components/itemListPasajero.js